<template>
<!-- 课程信息 -->
    <div class="stuInfo">
        <div  class="search-content conditionSearchBox">
            <div class="conditionItem">
                <el-input size="medium"  prefix-icon="el-icon-search" placeholder="课程名称" v-model="params.condition.name" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="hollowOut" @click="triggerSearch">
                    <i class="el-icon-search mr-5"></i>搜索</el-button>
                <el-button @click="resetSearchCondition">
                    <i class="el-icon-refresh mr-5"></i>重置</el-button>
            </div>
        </div>
        <div class="listBox mt-20">
            <el-button @click="addClass" type="primary"><span class="icon-add">+</span>新增课程</el-button>
             <!-- 表格 -->
             <div v-loading="loadingStatus" class="table-content mt-15">
                <el-table class="table-fixed-col" ref="multipleTable" border :data="tableData" style="width: 100%">
                    <el-table-column key="index" type="index" :width="getTableHeaderWidthByOrderCol()"  align="center" label="序号"
                        fixed="left">
                        <template slot-scope="scope">
                            <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150" show-overflow-tooltip key="name" align="center" prop="name" label="课程名称">
                        <template slot-scope="scope">
                            <div class="classBox">
                                <img :src="scope.row.coveratturl.split(',')[0]" alt="">
                                <span class="jumpname text-ellipse" @click="goPage(scope.row)">{{scope.row.name}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="120" key="score" align="center" prop="score" label="学分数">
                    </el-table-column>
                    <el-table-column width="120" key="finishperiodcount" align="center" prop="finishperiodcount" label="已上课/排课数">
                        <template slot-scope="scope">
                            <span>{{scope.row.finishperiodcount}}/{{scope.row.periodcount}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="140" key="begindate" align="center" prop="begindate" label="授课开始时间">
                    </el-table-column>
                    <el-table-column width="140" key="enddate" align="center" prop="enddate" label="授课结束时间">
                    </el-table-column>
                    <el-table-column width="140" key="finishcoursecount" align="center" prop="finishcoursecount" label="完成学员数">
                    </el-table-column>
                    <el-table-column :width="getTableHeaderWidthByOpButton3()" fixed="right" key="set" align="right" label="操作">
                        <template slot-scope="scope">
                            <div class="color-brand flex jc-sb ai-c">
                                <span v-if="scope.row.finishperiodcount<1" @click="edit(scope.row)" class="color-brand pointer">编辑</span>
                                <span v-else class="color-text-sec ">编辑</span>
                                <span v-if="scope.row.periodcount === scope.row.finishperiodcount && scope.row.finishperiodcoun>0" @click="endClass(scope.row)" class="color-brand pointer">结课</span>
                                <span v-else class="color-text-sec ">结课</span>
                                <span v-if="scope.row.finishperiodcount === 0" @click="del(scope.row)"  class="color-brand pointer">删除</span>
                                <span v-else class="color-text-sec ">删除</span>
                            </div>
                            
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    :hide-on-single-page="!total || total < 1"
                    class="mt-20 flex ai-c jc-fd"
                    @size-change="handePageSizeChange"
                    @current-change="curPageChange"
                    @prev-click="curPageChange"
                    @next-click="curPageChange"
                    layout="total, sizes, prev, pager, next"
                    :total="total"
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    :page-size="20"
                    :current-page.sync="params.page"
                    background
                ></el-pagination>
            </div>
        </div>
        <!-- 新增课程信息 -->
        <AddCourse ref="AddCourse" />
    </div>
</template>
<script>
import {getCourseList,updateCourseStatus} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import AddCourse from './components/addCourse.vue'
export default {
    data(){
        return {
            tableData: [],
            loadingStatus: false,
            total: 0,
            params: {
                condition: {
                    catecode: '',
                    catename: '',
                    classcode: this.$route.query.code,
                    classname: '',
                    name: '',
                    status: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            changeParams: {
                codes: '',
                status: ''
            },
            step: 1
        }
    },
    components: {
        TableSort,
        AddCourse
    },
    created(){
        // this.getCourseList()
    },
    methods: {
        init(){
            if(this.step === 1){
                this.getCourseList()
            }
        },
        getCourseList(){
            this.loadingStatus = true
            getCourseList(this.params).then(res => {
                 this.loadingStatus = false
                if(res.code === '000'){
                    this.step++
                    this.tableData = res.data
                    this.total = res.pageinfo.rowcount
                }
                console.log(res,'课程列表')
            }).catch(err => {
                 this.loadingStatus = false
            })
        },
        addClass(){
            this.$refs.AddCourse.init()
        },
        triggerSearch(){
            this.params.page = 1
            this.getCourseList()
        },
        resetSearchCondition(){
            this.params.condition.name = ''
            this.params.page = 1
            this.getCourseList()
        },
        updateCourseStatus(){
            updateCourseStatus(this.changeParams).then(res => {
                this.getCourseList()
                console.log(res,'修课程状态')
            })
        },
        edit(row){
            // this.changeParams.codes = row.code
            // this.changeParams.status = 11
            // this.updateCourseStatus()
            this.$refs.AddCourse.init(row.code)
        },
        endClass(row){
            this.changeParams.codes = row.code
            this.changeParams.status = 30
            this.updateCourseStatus()
        },
        del(row){
            this.changeParams.codes = row.code
            this.changeParams.status = 100
            this.$confirm('课程删除后将不在前台展示，但不影响已排课的课表，继续吗？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'measElMessage'
            }).then(() => {
                this.updateCourseStatus()
            })
        },
        goPage(row){
            this.$router.push({name: 'CourseDetail', query: {code: row.code, classCode: this.$route.query.code}})
        },
        handePageSizeChange(e){
            this.params.page = 1
            this.params.pagesize = e
            this.getCourseList()
        },
        curPageChange(e){
            console.log(e,'eee')
            this.params.page = 1
            this.params.page = e
            this.getCourseList()
        },
    }
}
</script>
<style lang="scss" scoped>
.jumpname{
    color: #409EFF;
    cursor: pointer;
}
.classBox{
    display: flex;
    align-items: center;
    img{
        height: 28px;
        width: 56px;
        margin-right: 10px;
    }
}
.stuInfo{
    .listBox{
        font-size: 14px;
        .icon-add{
            margin-right: 6px;
        }
    }
}

</style>